import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, } from 'react-bootstrap';
import Select from 'react-select';
import { ChooseComponent, useFetch, useTranslation, usePermission } from '@np/np_webcomponentlib'

import { API_BUSINESS } from '../../shared/consts/api'

import { EntityType, DataEntityType, EntityFormPropsWithType, initEntity, columnsForChoose } from './RateTypes'
import DRRateComissionList from '../DRRateComission/DRRateComissionList';


// import { ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'






export const RateForm = ({ title, idInit, handleClose, initEntityProps }: EntityFormPropsWithType) => {

    const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('$component_name');

    const [currentID, setCurrentID] = useState<string | null>(idInit)
    const [entity, setEntity] = useState<EntityType | DataEntityType>(initEntityProps !== undefined ? initEntityProps : initEntity)

    useEffect(() => {
        setCurrentID(idInit)
    }, [idInit])

    const [, doFetchLoad] = useFetch(
        `${API_BUSINESS}raterepo/${currentID}`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }


    
        const [, doFetchCreateUpdate] = useFetch(
            `${API_BUSINESS}raterepo`)//{ error: errCU, isLoading: isLoadCU, response: respCU }



    useEffect(() => {
        if (currentID === "") {
            return
        }
        doFetchLoad({
            method: 'GET',
            "Content-Type": "application/json"
        }).then(responce => {
            setEntity(responce.data)
            console.log(responce.data)
        })
    }, [currentID])


    const handleSave = () => {
        //сначала проверим заполненность

        var method = "POST"
        if (currentID !== "") {
            method = "PATCH"
        }

        doFetchCreateUpdate({
            method: method,
            "Content-Type": "application/json",
            data: entity
        }).then(responce => {
            console.log(responce)
            setEntity(responce.data)
            console.log("responce.result.status", responce.result.status)
            if (responce.result.status === "success") {
                handleClose();
            }
            console.log(responce.data)
        })


    }




    const confirmButtonTitle = "Загрузить";//useTranslation('confirmButtonTitle')
    const rejectButtonTitle = useTranslation('rejectButtonTitle')

    const createButtonTitle = useTranslation('createButton')
    const updateButtonTitle = useTranslation('updateButton')


    return (<Card>
        <Card.Header>
            <Card.Title as='h4'>{title}</Card.Title>
        </Card.Header>
        <Card.Body className="">
            {/* <Form className="form-horizontal"> */}

        

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('name')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('name')} value={entity.title} onChange={e => setEntity((prev) => { return { ...prev, title: e.target.value } })} />
                </Col>
            </Row>


            
            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('maxOperationPerHour')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('maxOperationPerHour')} value={entity.maxOperationPerHour} onChange={e => setEntity((prev) => { return { ...prev, maxOperationPerHour: parseInt(e.target.value) } })} />
                </Col>
            </Row>



            <Row className="mb-0">
                {canCreate && currentID === "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {createButtonTitle} </Button>
                }

                {canUpdate && currentID !== "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {updateButtonTitle} </Button>
                }


            </Row>


            <Row className="mb-0">
                {entity && entity.idUnique !== "" &&
                    <DRRateComissionList listFilterFieldProps={[{ fieldName: "idrfRate", comparison: "equalsStrong", listVal: [entity.idUnique ? String(entity.idUnique) : ""] }]}></DRRateComissionList>
                }
            </Row>




        </Card.Body>
    </Card>)
}
